// src/pages/TalleresNoAutorizadosList.jsx
import React, { useEffect, useState } from "react";
import { Table, Button, Typography, message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getTalleresNoAutorizados } from "../api/talleresNoAutorizadosApi";
import CreateTalleresNoAutorizadosForm from "./CreateTalleresNoAutorizadosForm";

const { Title } = Typography;

const TalleresNoAutorizadosList = () => {
  const [talleres, setTalleres] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();
  const { role } = useAuth();

  useEffect(() => {
    if (role !== "ADMIN") {
      message.error("Acceso no autorizado");
      navigate("/");
    }
  }, [role, navigate]);

  const fetchTalleres = async () => {
    try {
      const response = await getTalleresNoAutorizados();
      setTalleres(response.data);
    } catch (error) {
      console.error("Error fetching talleres no autorizados:", error);
      message.error("Error al obtener los talleres");
    }
  };

  useEffect(() => {
    fetchTalleres();
  }, []);

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleSuccess = () => {
    closeModal();
    fetchTalleres();
  };

  const columns = [
    { title: "Código", dataIndex: "codigo", key: "codigo" },
    { title: "Nombre", dataIndex: "nombre", key: "nombre" },
    { title: "Tipo Taller", dataIndex: "tipoTaller", key: "tipoTaller" },
    { title: "Dirección", dataIndex: "direccion", key: "direccion" },
    { title: "Ciudad", dataIndex: "ciudad", key: "ciudad" },
    {
      title: "Agencia Cercana",
      dataIndex: "agenciaCercana",
      key: "agenciaCercana",
    },
    { title: "Marca", dataIndex: "marca", key: "marca" },
    { title: "Latitud", dataIndex: "latitud", key: "latitud" },
    { title: "Longitud", dataIndex: "longitud", key: "longitud" },
  ];

  return (
    <div
      style={{
        background: "#1f1f1f",
        color: "#ccc",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 10px rgba(0,0,0,0.5)",
        minHeight: "calc(100vh - 80px)",
      }}
    >
      <Title level={2} style={{ color: "#fff" }}>
        Listado de Talleres No Autorizados
      </Title>
      <Button type="primary" onClick={openModal} style={{ marginBottom: 16 }}>
        Crear Taller
      </Button>

      <Table
        columns={columns}
        dataSource={talleres}
        rowKey="id"
        style={{
          background: "#2a2a2a",
          color: "#ccc",
        }}
      />

      <Modal
        title={
          <span style={{ color: "#fff" }}>Crear Taller No Autorizado</span>
        }
        open={modalVisible}
        onCancel={closeModal}
        footer={null}
        destroyOnClose
        bodyStyle={{ background: "#1f1f1f", color: "#ccc" }}
      >
        <CreateTalleresNoAutorizadosForm
          onSuccess={handleSuccess}
          onCancel={closeModal}
        />
      </Modal>
    </div>
  );
};

export default TalleresNoAutorizadosList;
